import React from 'react';
import { Layout, Label, enums } from 'console-kit';
import emailDomainUtils from './emailDomainUtils';

/**
 * Small component to render the "Create custom domain" message.
 */
const MissingCustomEmailDomain = () => (
  <React.Fragment>
    You do not have your email domain setup in your account and are currently using the shared @wayin.info domain for
    sending these emails. Using a shared domain is not recommended and you will no longer be able to use this domain
    after 01 July 2024. You'll probably already have a corporate/brand email domain or{' '}
    <a
      className="inverted text-href"
      href="https://www.forbes.com/advisor/business/how-get-custom-email-domain/"
      target="_blank"
    >
      you can get one
    </a>
    . Once you have it, please contact support to add your email domain(s) in your Grow account.
  </React.Fragment>
);

/**
 * Component to show the Email domain warnings depending on the list of available email domains in the account.
 * Displays a warning, if the user still uses a deprecated domain and
 * 1) There are some not deprecated (custom) domains in the list -> show "Select another domain" message;
 * 2) There are no custom domains => show "Create custom domain" message.
 */
const EmailNotificationsWarnings = ({ domainName, domainOptions }) => {
  const usingDeprecatedDomain = domainName === emailDomainUtils.DEPRECATED_EMAIL_DOMAIN;
  const showSelectCustomDomainWarning =
    usingDeprecatedDomain && emailDomainUtils.filterNonDeprecatedDomains(domainOptions).length > 0; // if account has some custom domains
  const showCreateCustomDomainWarning =
    usingDeprecatedDomain && emailDomainUtils.filterNonDeprecatedDomains(domainOptions).length === 0; // if account does not have any custom domain

  return (
    <React.Fragment>
      <If condition={showCreateCustomDomainWarning}>
        <Layout.Row>
          <Label text={<MissingCustomEmailDomain />} icon={enums.icons.WARNING} color={enums.colors.WARNING} />
        </Layout.Row>
      </If>

      <If condition={showSelectCustomDomainWarning}>
        <Layout.Row>
          <Label
            text="Wayin.info is a shared domain which is not recommended. Please switch to using your own custom email domain from the dropdown above."
            icon={enums.icons.WARNING}
            color={enums.colors.WARNING}
          />
        </Layout.Row>
      </If>
    </React.Fragment>
  );
};

export default EmailNotificationsWarnings;
